import {AppState} from '../reducer';

export const showHtmlCodeEditorModal = (state: AppState): boolean => state.htmlReducer.showEditorModal;
